import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    id: "Close",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeApp()))
  }, [...(_cache[1] || (_cache[1] = [
    _createElementVNode("i", { class: "lnr-cross CrossIcon" }, null, -1 /* CACHED */)
  ]))]))
}